var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-text-box-style",class:_vm.labels.backgroundColorClass},[_c('tws-rich-text',{attrs:{"html":_vm.labels.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }